export default __webpack_public_path__ + "static/media/personnel_grey.8ffce70e.svg";